import React, { Component } from "react";
import {
  Row,
  Col,
  Card,
  CardBody,
  Collapse,
  Label,
  FormGroup,
  Input,
} from "reactstrap";
import history from "../../history";
import moment from "moment";

import CartTitle from "../CartTitle";
import Loader from "../Loader";
import MaterialTable from "material-table";
import {
  helperFunctionForCountry,
  helperFunctionForDate,
  helperFunctionForBooleanValue,
} from "../../utils/helperFunction";
import CustomDatepicker from "../CustomDatepicker";

import CustomButton from "../CustomButton";
import InputText from "../InputText";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../assets/scss/components/MeterialTable/index.scss";

import get from "lodash/get";

const _ = { get };

export default class OnBoardedUserList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toggleActive: true,
      toggleCollapse: false,
      pageSize: 10,
      page: 0,
      count: 100,
      startDate: new Date("04/01/2021"),
      endDate: new Date().setFullYear(new Date().getFullYear()),
      email: "",
      firstName: "",
      clubMember: "",
      countryCode: "",
      country: "",
      state: "",
      city: "",
      dealerId: "",
      dealerName: "",
      countryList: [],
      parsedCountry: "",
    };
  }

  componentDidMount() {
    let obj = {
      page: this.state.page,
      count: this.state.count,
      startDate: moment(this.state.startDate).format("DD/MM/YYYY"),
      endDate: moment(this.state.endDate).format("DD/MM/YYYY"),
      email: this.state.email,
      firstName: this.state.firstName,
      clubMember: this.state.clubMember,
      dealerId: this.state.dealerId,
      countryCode: this.state.countryCode,
      state: this.state.state,
      city: this.state.city,
    };
    this.props.handleFetchOnBoardUserList(obj);
    this.handleSetCountries();
  }

  componentDidUpdate(prevProps, prevState) {
    let countries = JSON.parse(localStorage.getItem("countries"));
    let accessibleCountries = JSON.parse(
      localStorage.getItem("accessCountries")
    );
    console.log(accessibleCountries, countries);
    if (prevProps.onBoardedUser.length !== this.props.onBoardedUser.length) {
      let state = this.state;
      state.page = Math.ceil(
        this.props.onBoardedUser.length / this.state.count
      );
      this.setState({ ...state });
    }
    console.log(this.props.dealers);
  }

  handleSetCountries = () => {
    let countries = JSON.parse(localStorage.getItem("countries"));
    let accessibleCountries = JSON.parse(
      localStorage.getItem("accessCountries")
    );
    console.log(accessibleCountries, countries);
    if (accessibleCountries && accessibleCountries[0] === "*") {
      let state = this.state;
      state.countryList = countries;
      console.log("===Star state===", this.state.countryList);
      this.setState({ ...state });
    }
    if (accessibleCountries && accessibleCountries[0] !== "*") {
      let state = this.state;
      let newCountry = countries.filter((data) =>
        accessibleCountries.includes(data.locality.country)
      );
      state.countryList = newCountry;
      let code = newCountry[0].locality.country;
      let countryName = newCountry[0].country;

      state.countryCode = code;
      state.country = countryName;
      console.log("===Non Star state===", this.state.countryList);
      this.setState({ ...state });
    }
  };

  handleRowData = (data) => {
    history.push(`/user/onboard-users-Detail?userId=${data._id}`);
  };

  handleOnChangePageSize = (count) => {
    let state = this.state;
    state.pageSize = count;
    this.setState({ ...state });
  };

  handleChangeDealer = (e) => {
    let state = this.state;
    let value = JSON.parse(e.target.value);
    state.dealerId = value._id;
    state.dealerName = value.dealerName;

    this.setState({ ...state });
  };

  handleCountryChange = (e) => {
    let state = this.state;
    if (e.target.value !== "") {
      let parsedValue = JSON.parse(e.target.value);
      state.countryCode = parsedValue.locality.country;
      state.country = parsedValue.country;
      state.state = "";
      state.city = "";
      state.dealerId = "";
      state.dealerName = "";
    } else {
      state.countryCode = "";
      state.country = "";
    }
    state.parsedCountry = e.target.value;
    this.setState({ ...state });
    this.props.handleFetchState(state.countryCode);
  };

  handleStateChange = (e) => {
    let state = this.state;
    let parsedValue = JSON.parse(e.target.value);
    if (e.target.value !== "Select Country") {
      state.state = parsedValue;
      state.city = "";
      state.dealerId = "";
      state.dealerName = "";
    }
    this.setState({ ...state });
    let data = {
      countryCode: state.countryCode,
      state: state.state,
    };
    let dataForDealer = {
      country: state.countryCode,
      state: state.state,
      city: state.city,
      emailId: "",
      phone: "",
      dealerId: "",
      limit: "",
      page: 0,
    };
    this.props.handleFetchDealer(dataForDealer);
    this.props.handleFetchCity(data);
  };

  handleCityChange = (e) => {
    let state = this.state;
    let parsedValue = JSON.parse(e.target.value);
    if (e.target.value !== "Select Country") {
      state.city = parsedValue.cityName;
      state.dealerId = "";
      state.dealerName = "";
    }
    this.setState({ ...state });
    let data = {
      country: state.countryCode,
      state: state.state,
      city: state.city,
      emailId: "",
      phone: "",
      dealerId: "",
      limit: "",
      page: 0,
    };
    this.props.handleFetchDealer(data);
  };

  handleEmailChange = (e) => {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState({ ...state });
  };

  handleFilterChange = (e) => {
    let state = this.state;
    state[e.target.name] = e.target.value;
    this.setState({ ...state });
  };

  handleOnPageChange = (e, page) => {
    let totalPages = this.props.onBoardedUser.length / this.state.pageSize;
    let fetchNextData =
      e >= totalPages - 2 &&
      this.props.onBoardedUser.length !== 0 &&
      this.props.onBoardedUserStatus === false &&
      this.props.onBoardedUser.length < this.props.onBoardedUserCount;

    if (fetchNextData === true) {
      let obj = {
        page: this.state.page,
        count: this.state.count,
        startDate: moment(this.state.startDate).format("DD/MM/YYYY"),
        endDate: moment(this.state.endDate).format("DD/MM/YYYY"),
        email: this.state.email,
        firstName: this.state.firstName,
        clubMember: this.state.clubMember,
        dealerId: this.state.dealerId,
        countryCode: this.state.countryCode,
        state: this.state.state,
        city: this.state.city,
      };
      this.props.handleFetchOnBoardUserList(obj);
    }
  };

  handleFilterDates = (date, id) => {
    let state = this.state;
    if (id === "start") {
      state.startDate = date;
      state.endDate = "";
      this.setState({ ...state });
    }
    if (id === "end") {
      state.endDate = date;
      this.setState({ ...state });
    }
  };

  handleToggle = (e) => {
    let state = this.state;
    state.toggleActive = !state.toggleActive;
    if (state.toggleCollapse === true) {
      state.toggleCollapse = !state.toggleCollapse;
      this.setState({ ...state });
    }
    this.setState({ ...state });
  };

  handleToggleIcon = (e) => {
    let state = this.state;
    state.toggleCollapse = !state.toggleCollapse;
    if (state.toggleActive === true) {
      state.toggleActive = !state.toggleActive;
      this.setState({ ...state });
    }
    this.setState({ ...state });
  };

  handleClearFilter = () => {
    let state = this.state;
    state.startDate = "";
    state.endDate = "";
    state.email = "";
    state.dealerId = "";
    state.dealerName = "";
    state.country = "";
    state.countryCode = "";
    state.state = "";
    state.city = "";
    state.page = 0;
    state.parsedCountry = "";

    this.setState({ ...state });
    let obj = {
      page: 0,
      count: this.state.count,
      startDate: "",
      endDate: "",
      email: "",
      firstName: "",
      clubMember: "",
      dealerId: "",
      countryCode: "",
      state: "",
      city: "",
    };
    this.props.handleFetchOnBoardUserList(obj);
    this.props.handleClearPreviousReducers();
  };

  handleExportData = (e) => {
    let state = this.state;
    let { elements } = this.props;
    let obj = {
      email: state.email,
      startDate: state.startDate,
      endDate: state.endDate,
      firstName: state.firstName,
      clubMember: state.clubMember,
      key: "onboardUser",
    };
    if (state.email === "")
      return toast.error(
        _.get(
          elements,
          "onBoardListElements.emailValidationElement",
          "Email cannot be empty"
        )
      );
    return this.props.handleExportToExcel(obj);
  };

  handleSearch = () => {
    let state = this.state;
    let obj = {
      page: 0,
      count: state.count,
      email: state.email,
      firstName: state.firstName,
      clubMember: state.clubMember,
      startDate:
        state.startDate !== ""
          ? moment(state.startDate).format("DD/MM/YYYY")
          : "",
      endDate:
        state.endDate !== "" ? moment(state.endDate).format("DD/MM/YYYY") : "",
      dealerId: state.dealerId,
      countryCode: state.countryCode,
      state: state.state,
      city: state.city,
    };
    this.props.handleFetchOnBoardUserList(obj);
    this.props.handleClearPreviousReducers();
  };

  render() {
    let { elements } = this.props;
    console.log({ fetchedStates: this.props.states });
    return (
      <div className="userListing hideSearch">
        {this.props.onBoardedUserStatus !== false ? <Loader /> : null}
        <Row>
          <Col sm={12}>
            <CartTitle
              title={_.get(
                elements,
                "onBoardListElements.headingElement",
                "Registered Users"
              )}
              Name={_.get(
                elements,
                "onBoardListElements.filterButtonElement",
                "Filter"
              )}
              handleToggle={() => this.handleToggle()}
              iconClass={"hideexcel"}
              customExcelClick={() => this.handleToggleIcon()}
              textTitle={_.get(
                elements,
                "onBoardListElements.totalCountElement",
                "Total Count - "
              )}
              preRegisteredUserCount={this.props.onBoardedUserCount}
            />
          </Col>
          <Col sm={12}>
            <Collapse isOpen={this.state.toggleActive}>
              <Card className="mb-3">
                <CardBody>
                  {this.props.usertype && this.props.usertype === "Admin" ? (
                    <Row>
                      <Col xl={4} lg={4} md={6} sm={6}>
                        <FormGroup className=" confirmRiderSelect select_options">
                          {this.props.accessibleCountries &&
                          this.props.accessibleCountries.length === 1 &&
                          this.props.accessibleCountries[0] !== "*" ? (
                            <Input
                              type="select"
                              name="City"
                              className="w-100 customeSelectBtn"
                              onChange={this.handleCountryChange}
                              value={this.state.parsedCountry}
                            >
                              {this.state.countryList &&
                                this.state.countryList.length > 0 &&
                                this.state.countryList
                                  .sort((a, b) =>
                                    a.name > b.name
                                      ? 1
                                      : b.name > a.name
                                      ? -1
                                      : 0
                                  )
                                  .map((item, index) => (
                                    <option
                                      key={index}
                                      value={JSON.stringify(item)}
                                    >
                                      {item.country}
                                    </option>
                                  ))}
                            </Input>
                          ) : (
                            <Input
                              type="select"
                              name="City"
                              className="w-100 customeSelectBtn"
                              onChange={this.handleCountryChange}
                              value={this.state.parsedCountry}
                            >
                              <option value="">
                                {_.get(
                                  elements,
                                  "onBoardListElements.CountryLabel",
                                  "All Countries"
                                )}
                              </option>
                              {this.state.countryList &&
                                this.state.countryList.length > 0 &&
                                this.state.countryList
                                  .sort((a, b) =>
                                    a.name > b.name
                                      ? 1
                                      : b.name > a.name
                                      ? -1
                                      : 0
                                  )
                                  .map((item, index) => (
                                    <option
                                      key={index}
                                      value={JSON.stringify(item)}
                                    >
                                      {item.country}
                                    </option>
                                  ))}
                            </Input>
                          )}
                        </FormGroup>
                      </Col>
                      <Col xl={4} lg={4} md={6} sm={6}>
                        <FormGroup className=" confirmRiderSelect select_options">
                          <Input
                            type="select"
                            name="branchType"
                            className="w-100 customeSelectBtn"
                            onChange={this.handleStateChange}
                            value={this.state.state}
                            disabled={this.state.countryCode === ""}
                          >
                            <option>
                              {this.state.state !== ""
                                ? this.state.state
                                : _.get(
                                    elements,
                                    "onBoardListElements.selectStateLabel",
                                    "Select State"
                                  )}
                            </option>
                            {this.props.states
                              .sort((a, b) =>
                                a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                              )
                              .map((item, index) => (
                                <option
                                  key={index}
                                  value={JSON.stringify(item)}
                                >
                                  {item}
                                </option>
                              ))}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col xl={4} lg={4} md={6} sm={6}>
                        <FormGroup className=" confirmRiderSelect select_options">
                          <Input
                            type="select"
                            name="branchType"
                            className="w-100 customeSelectBtn"
                            onChange={this.handleCityChange}
                            value={this.state.city}
                            disabled={this.state.state === ""}
                          >
                            <option>
                              {this.state.city !== ""
                                ? this.state.city
                                : _.get(
                                    elements,
                                    "onBoardListElements.selectCityLabel",
                                    "Select City"
                                  )}
                            </option>
                            {this.props.cities
                              .sort((a, b) =>
                                a.name > b.name ? 1 : b.name > a.name ? -1 : 0
                              )
                              .map((item, index) => (
                                <option
                                  key={index}
                                  value={JSON.stringify(item)}
                                >
                                  {item.cityName}
                                </option>
                              ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                  ) : null}

                  <Row>
                    {this.props.usertype && this.props.usertype === "Admin" ? (
                      <Col xl={4} lg={4} md={6} sm={6}>
                        <Label className="inputLabel">
                          {_.get(
                            elements,
                            "userMembershipListingFilterElements.dealerLabel",
                            "Dealer"
                          )}
                        </Label>
                        <FormGroup className=" confirmRiderSelect select_options">
                          <Input
                            type="select"
                            name="City"
                            className="w-100 customeSelectBtn"
                            onChange={this.handleChangeDealer}
                            value={this.state.dealerName}
                            disabled={this.state.state === ""}
                          >
                            <option>
                              {this.state.dealerName !== ""
                                ? this.state.dealerName
                                : "Select Dealer"}
                            </option>
                            {this.props.dealers
                              .sort((a, b) =>
                                a.dealerName > b.dealerName
                                  ? 1
                                  : b.dealerName > a.dealerName
                                  ? -1
                                  : 0
                              )
                              .map((item, index) => (
                                <option
                                  key={index}
                                  value={JSON.stringify(item)}
                                >
                                  {item.dealerName}
                                </option>
                              ))}
                          </Input>
                        </FormGroup>
                      </Col>
                    ) : null}

                    <Col lg={4} className="mb-3 mb-lg-0">
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "onBoardListElements.startDateLabelElement",
                          "Start Date"
                        )}{" "}
                      </Label>
                      <FormGroup>
                        <CustomDatepicker
                          value={this.state.startDate}
                          customPlaceHolder={_.get(
                            elements,
                            "onBoardListElements.startDatePlaceHolderElement",
                            "Select Start Date"
                          )}
                          handleDateChange={(e) =>
                            this.handleFilterDates(e, "start")
                          }
                          customShowMonthDropdown={true}
                          customShowYearDropdown={true}
                          customMaxDate={new Date()}
                          // customMinDate={new Date("04/01/2021")}
                          // customDisable={this.state.dealerId === ""}
                        />
                      </FormGroup>
                    </Col>

                    <Col lg={4} className="mb-3 mb-lg-0">
                      <Label className="inputLabel">
                        {_.get(
                          elements,
                          "onBoardListElements.endDateLabelElement",
                          "End Date"
                        )}
                      </Label>
                      <FormGroup>
                        <CustomDatepicker
                          value={this.state.endDate}
                          customPlaceHolder={_.get(
                            elements,
                            "onBoardListElements.endDatePlaceHolderElement",
                            "Select End Date"
                          )}
                          handleDateChange={(e) =>
                            this.handleFilterDates(e, "end")
                          }
                          customShowMonthDropdown={true}
                          customShowYearDropdown={true}
                          customMinDate={this.state.startDate}
                          // customMaxDate={new Date()}
                          customDisable={
                            this.state.startDate === "" ? true : false
                          }
                        />
                      </FormGroup>
                    </Col>

                    <Col lg={4}>
                      <InputText
                        labelName={_.get(
                          elements,
                          "userMembershipListingFilterElements.emailLabel",
                          "Email"
                        )}
                        inputType={"email"}
                        inputName={"email"}
                        InputClass={"inputText mb-0"}
                        inputPlaceholder={_.get(
                          elements,
                          "userMembershipListingFilterElements.emailPlaceholder",
                          "Email"
                        )}
                        customValue={this.state.email}
                        customOnChange={(e) => this.handleFilterChange(e)}
                        // customDisable={this.state.endDate === ""}
                      />
                    </Col>

                    <Col lg={12}>
                      <div className="d-flex justify-content-end">
                        <CustomButton
                          customType={"submit"}
                          name={_.get(
                            elements,
                            "onBoardListElements.searchButtonElement",
                            "Search"
                          )}
                          customClass={"btn-outline-dark bg-none btnthemeColor"}
                          customClick={() => this.handleSearch()}
                          // customDisable={this.state.country === ""}
                        />

                        <CustomButton
                          customType={"button"}
                          name={_.get(
                            elements,
                            "onBoardListElements.clearFilterElement",
                            "Clear Filter"
                          )}
                          customClass={
                            "btn-outline-dark ml-2 bg-none btnthemeColor"
                          }
                          customClick={() => this.handleClearFilter()}
                          // customDisable={this.state.country === ""}
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Collapse>
            <Collapse isOpen={this.state.toggleCollapse}>
              <Card className="mb-3">
                <CardBody>
                  <Row>
                    <Col lg={4}>
                      <Row>
                        <Col lg={8}>
                          <InputText
                            labelName={_.get(
                              elements,
                              "onBoardListElements.emailLabelElement",
                              "Email"
                            )}
                            inputType={"email"}
                            inputName={"email"}
                            InputClass={"inputText mb-0"}
                            inputPlaceholder={_.get(
                              elements,
                              "onBoardListElements.emailPlaceholderElement",
                              "Email"
                            )}
                            customValue={this.state.email}
                            customOnChange={(e) => this.handleEmailChange(e)}
                          />
                        </Col>

                        <Col
                          lg={4}
                          className="d-flex justify-content-center align-items-center"
                        >
                          <div className="mt-2 pt-1">
                            <CustomButton
                              customType={"button"}
                              name={_.get(
                                elements,
                                "onBoardListElements.exportToExcelButton",
                                "Export To Excel"
                              )}
                              customClass={
                                "btn-outline-dark ml-2 bg-none btnthemeColor"
                              }
                              customClick={() => this.handleExportData()}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Collapse>
          </Col>
        </Row>
        <Row>
          <Col sm="12">
            <div className="custom-m-table">
              <MaterialTable
                title=""
                columns={[
                  {
                    title: _.get(
                      elements,
                      "onBoardListElements.fistNameElement",
                      "First Name"
                    ),
                    field: "fName",
                  },
                  {
                    title: _.get(
                      elements,
                      "onBoardListElements.lastNameElement",
                      "Last Name"
                    ),
                    field: "lName",
                  },
                  {
                    title: _.get(
                      elements,
                      "onBoardListElements.ClubMemberElement",
                      "Club Member"
                    ),
                    field: "ridersClubMember",
                    render: (rowData) => {
                      return helperFunctionForBooleanValue(
                        rowData.ridersClubMember
                      );
                    },
                  },
                  {
                    title: _.get(
                      elements,
                      "onBoardListElements.CreatedOnElement",
                      "Created on"
                    ),
                    field: "createdOn",

                    render: (rowData) => {
                      return helperFunctionForDate(rowData.createdOn);
                    },
                  },
                  {
                    title: _.get(
                      elements,
                      "onBoardListElements.CountryElement",
                      "Country"
                    ),
                    field: "country",
                    render: (rowData) => {
                      return helperFunctionForCountry(rowData.locality.country);
                    },
                  },
                  {
                    title: _.get(
                      elements,
                      "onBoardListElements.sourceElement",
                      "Source"
                    ),
                    field: "source",
                  },
                ]}
                data={this.props.onBoardedUser}
                options={{
                  actionsColumnIndex: -1,
                  search: false,
                  paging: true,
                  sorting: false,
                  pageSize: this.state.pageSize,
                  paginationType: "stepped",
                  initialPage: 1,
                  showFirstLastPageButtons: false,
                }}
                onChangeRowsPerPage={(e) => this.handleOnChangePageSize(e)}
                onChangePage={(e, page) => this.handleOnPageChange(e, page)}
                localization={{
                  body: {
                    emptyDataSourceMessage: (
                      <h6>
                        {_.get(
                          elements,
                          "onBoardListElements.noRecordsFoundElement",
                          "No records to display"
                        )}
                      </h6>
                    ),
                  },
                  pagination: {
                    labelRowsSelect: _.get(
                      elements,
                      "customMaterialTableElement.labelRowsSelect",
                      "rows"
                    ),
                    previousTooltip: _.get(
                      elements,
                      "customMaterialTableElement.previousTooltip",
                      "previous"
                    ),
                    nextTooltip: _.get(
                      elements,
                      "customMaterialTableElement.nextTooltip",
                      "next"
                    ),
                  },
                }}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
